// Centralised API base URL helper.
//
// Why this exists: in production the deployed frontend may live on a custom
// domain (e.g. https://puropilatesreformer.com) while REACT_APP_BACKEND_URL
// might still point to the preview origin baked at build time. Browsers like
// Safari (with Intelligent Tracking Prevention) then block credentialed
// cross-origin requests, breaking auth/login/register entirely.
//
// To make the app robust on every environment (preview, production, any
// custom domain) we use the env var ONLY when it matches the current origin.
// Otherwise we fall back to a same-origin relative URL — the Kubernetes
// ingress always routes /api/* to the backend on the same hostname.

const ENV_URL = process.env.REACT_APP_BACKEND_URL || '';

function resolveApiBase() {
  if (typeof window === 'undefined') return ENV_URL;
  if (!ENV_URL) return '';
  try {
    const envOrigin = new URL(ENV_URL).origin;
    if (envOrigin === window.location.origin) return ENV_URL;
    // Cross-origin → use same origin to avoid CORS / ITP issues
    return '';
  } catch (e) {
    return ENV_URL;
  }
}

export const API_BASE = resolveApiBase();
export const API = `${API_BASE}/api`;
